import { render, staticRenderFns } from "./vsSpacer.vue?vue&type=template&id=2562a105"
import script from "./vsSpacer.vue?vue&type=script&lang=js"
export * from "./vsSpacer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports